import { useCalendarStore } from "../../store/useCalendarStore";
import { useTimeOffDrag } from "../hooks/useTimeOffDrag";
import { TimeOffScopeDialog } from "./TimeOffScopeDialog";

/**
 * Asks what a dragged occurrence's new position applies to. Only a series
 * occurrence gets here — a standalone one is written on drop, since the drag
 * itself is the confirmation.
 */
export function TimeOffDropScope() {
  const pendingTimeOffDrop = useCalendarStore(
    (state) => state.pendingTimeOffDrop,
  );
  const setPendingTimeOffDrop = useCalendarStore(
    (state) => state.setPendingTimeOffDrop,
  );
  const { commit, cancelDrop } = useTimeOffDrag();

  if (pendingTimeOffDrop == null) return null;

  return (
    <TimeOffScopeDialog
      isOpen
      isDelete={false}
      allowFollowing={pendingTimeOffDrop.allowFollowing}
      // The block has already been moved locally, so dismissing has to put it
      // back — nothing was written, so the server's rows are the truth.
      onDismiss={() => void cancelDrop()}
      onChoose={async (scope) => {
        const drop = pendingTimeOffDrop;
        setPendingTimeOffDrop(null);
        await commit(drop, scope);
      }}
    />
  );
}
